import React from "react";

function TransactionBankList(bankAmount, formatNumber) {
  return bankAmount?.map((item) => ({
    title: item?._id,
    data: formatNumber(item?.totalAmount) || 0,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        width="30"
        height="30"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"
        />
      </svg>
    ),
    color: "warning",
  }));
}

export default TransactionBankList;
